import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PasswordValidator } from './../../../validator/password-validator';
import { Router } from '@angular/router';

import { AuthService } from './../../../services/auth.service';
import { MemberService } from './../../../rest/api/member.service';
import { HelperService } from './../../../services/helper.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  accessToken: any;
  changePasswordForm: FormGroup;

  userData: any;
  loader = true;

  isSubmitting = false;
  isSubmitted = false;

  errors = [];
  successMsg: string;
  errorMsg: string;
  constructor(
    public router: Router,
    public fb: FormBuilder,
    private authService: AuthService,
    public memberService: MemberService,
    public helperService: HelperService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
    this.updatePasswordFormInit();
    this.loader = false;
  }

  updatePasswordFormInit() {
    this.changePasswordForm = this.fb.group({
      old_password: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(40)]],
      confirm_password: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(40)]]
    },
    {
      validator: [PasswordValidator.MatchPassword]
    });
  }

  submit(value) {
    if (!this.changePasswordForm.valid) {
      this.isSubmitting = true;
      return;
    }
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.resetErrors();
    const data = value;
    this.changePassword(data);
  }

  resetErrors() {
    this.errorMsg = undefined;
    this.errors = [];
  }

  changePassword(data) {
    let formData;
    formData = {
      old_password: data.old_password,
      new_password: data.password,
      confirm_password: data.confirm_password
    };
    formData = this.helperService.updateJsonFormat(formData);
    this.memberService.changePassword({
      Authorization: this.accessToken,
      body: formData
    }).subscribe((response: any) => {
      this.resetForm();
      this.successMsg = 'Password was changed sucessfully.';
      setTimeout(() => {
        this.router.navigate(['/member/settings/profile']);
      }, 2000);
    }, err => {
      this.loader = false;
      this.handleErrors(err);
    });
  }

  resetForm() {
    this.isSubmitted = false;
    this.isSubmitting = false;
    this.resetFormValues();
  }

  resetFormValues() {
    this.changePasswordForm.reset();
  }

  handleErrors(err) {
    if (err.error && err.error.errors) {
      this.errors = err.error.errors;
    } else if (err.error && err.error.error) {
      this.errorMsg = err.error.error;
    } else {
      this.errorMsg = 'There was error while updating password.';
    }
    this.isSubmitted = false;
    this.isSubmitting = false;
    setTimeout(() => {
      this.resetErrors();
    }, 5000);
  }

}
